import Api from '../api';

let uri = '/api/ed/etiqueta';

export const getPalabrasClave = () => {
    return Api.getInstance().executeGetQuery(`${uri}`)
    .then((resp) => resp.data)
    .catch((error) =>
        console.log(error)
    );
}

export const createPalabraClave = (data) => {
    return Api.getInstance().executeQuery(uri, data)
    .then(res => res)
    .catch(err => console.log(err));
}

export const editPalabraClave = (data)  => {
    return Api.getInstance().executeUpdateQuery(uri, data)
    .then(res => res)
    .catch(err => console.log(err));
}

export const deletePalabraClave = (data)  => {
    return Api.getInstance().executeDeleteQuery(uri, {data: data})
    .then(res => res)
    .catch(err => console.log(err));
}


export const asignarPalabraClave = (data) => {
    return Api.getInstance().executeQuery(`${uri}/asignacion`, data)
    .then(res => res.data)
    .catch(err => console.log(err));
}


